<template>
  <div class="graphics container">
    <canvas class="canvas" id="dotacion-edad"></canvas>
  </div>
</template>

<script>
import { Chart, registerables } from "chart.js";
Chart.register(...registerables);

export default {
  data() {
    return {
      img: "",
      myChart: null,
      graphicLabels: null,
      graphicData: null,
    };
  },
  props: ["labels", "data"],
  watch: {
    labels: function() {
      this.graphicLabels = this.$props.labels;
    },
    data: function() {
      this.graphicData = this.$props.data;

      this.grafica();
    },
  },
  methods: {
    grafica: function() {
      var ctx = document.getElementById("dotacion-edad").getContext("2d");
      if (this.myChart) {
        this.myChart.destroy();
      }
      const footer = (tooltipItems) => {
        var sum = 0;

        tooltipItems.forEach((tooltipItem) => {
          sum = `Hombres: ${this.graphicData.perc.h[tooltipItem.parsed.x]}%\nMujeres: ${this.graphicData.perc.m[tooltipItem.parsed.x]}%`;
        });
        return sum;
      };
      this.myChart = new Chart(ctx, {
        type: "bar",
        data: {
          labels: this.graphicLabels,
          datasets: [
            {
              label: "Mujeres",
              data: this.data.m,
              backgroundColor: ["#2ecc71"],
              borderColor: ["#2ecc71"],
              barThickness: 40,
            },
            {
              label: "Hombres",
              data: this.graphicData.h,
              backgroundColor: ["#770baa"],
              borderColor: ["#770baa"],
              barThickness: 40,
            },
          ],
        },
        options: {
          scales: {
            y: {
              beginAtZero: true,
              title: {
                display: true,
                text: "Personas",
                font: {
                  weight: "bold",
                },
              }
            },
            x: {
              title: {
                display: true,
                text: "Edad",
                font: {
                  weight: "bold",
                },
              },
              grid: {
                display: false
              }
            }
          },
          plugins: {
            legend: {
              display: true,
              position: "bottom",
            },
            tooltip: {
              callbacks: {
                footer: footer,
              },
            },
          },
        },
      });
    },
  },
  mounted() {},
};
</script>

<style scoped>
.canvas {
  font-size: 14px;
  color: #052333;
}
.graphics {
  padding-bottom: 2rem;
  padding: 1rem 5rem;
}
</style>
